export default class DetalheImportacaoClienteModel {
  clientes: Clientes;
  importacao: Importacao;
  constructor() {
    this.clientes = new Clientes();
    this.importacao = new Importacao();

  }
}
export class Cliente {
  tipo_sexo: string;
  idade: number;
  id_usuarios: number;
  nome: string;
  email?: any;
  celular: string;
  data_nascimento?: any;
  sexo?: any;
}

export class Row {
  id_cliente_empresa: number;
  id_usuario: number;
  id_empresa: number;
  id_importacao_cliente: number;
  data_cadastro?: any;
  data_desativacao?: any;
  cliente: Cliente;

  constructor() {
    this.cliente = new Cliente();
  }
}

export class Clientes {
  count: number;
  rows: Row[];
}

export class Importacao {
  id_importacao_cliente: number;
  id_empresa: number;
  status: string;
  error?: any;
  data_cadastro: Date;
  data_atualizacao: Date;
  total_itens: number;
  total_itens_importado: number;
}
